import { render, staticRenderFns } from "./vulidateError.vue?vue&type=template&id=2959b06c"
import script from "./vulidateError.vue?vue&type=script&lang=js"
export * from "./vulidateError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports